const TRestaurantSectionsModal = {
    // English
    "enUS": {
        'RESTAURANT_SECTIONS': 'Restaurant Sections',
        'RESTAURANT_SECTIONS_DESC': 'If you want to use the "Call a waiter" functionality you must use the QR codes generated in here',
        'SAVE': 'Save',
        'SECTIONS': 'Sections',
        'ADD_SECTION': 'Add Section',
        'ADD_TABLES': 'Add Tables',
        'GENERATE_QR_CODES': 'QR Codes',
        'NEW_SECTION': 'New Section',
        'SECTION_NAME': 'Section Name',
        'EDIT': 'Edit',
        'DELETE': 'Delete',
        'CANCEL': 'Cancel',
        'DELETE_SECTION_TITLE': 'Delete section',
        'DELETE_SECTION_TEXT': 'Do you wish to delete this section for your menu?',
        'CONFIRM_DELETE_SECTION_TEXT': 'Delete',
        'QUANTITY': 'Quantity',
        'MENU': "Restaurant's Menu",
    },
    // Spanish
    "esMX": {
        'RESTAURANT_SECTIONS': 'Secciones del Restaurante',
        'RESTAURANT_SECTIONS_DESC': 'Si deseas usar la funcionalidad de "Llamar a un mesero" debes usar los códigos QR generados aquí',
        'SAVE': 'Guardar',
        'SECTIONS': 'Secciones',
        'ADD_SECTION': 'Agregar Sección',
        'ADD_TABLES': 'Agregar Mesas',
        'GENERATE_QR_CODES': 'Códigos QR',
        'CHANGE_PROMOS': 'Cambiar Promociones',
        'NEW_SECTION': 'Nueva Sección',
        'SECTION_NAME': 'Nombre de Sección',
        'EDIT': 'Editar',
        'DELETE': 'Borrar',
        'CANCEL': 'Cancelar',
        'DELETE_SECTION_TITLE': 'Borrar sección',
        'DELETE_SECTION_TEXT': 'Desea borrar esta sección de su menú?',
        'CONFIRM_DELETE_SECTION_TEXT': 'Borrar',
        'QUANTITY': 'Cantidad',
        'MENU': "Menú del Restaurante",
    }
}
export default TRestaurantSectionsModal;